import type { Easing } from 'framer-motion';

/** משך מעבר תוכן פאנל כלים (מילישניות; Framer מצפה לשניות → מחלקים ב־1000) */
export const TOOLS_PANEL_TRANSITION_MS = 280;

/** ease-out חלק — תואם לשאר אנימציות הפרויקט */
export const TOOLS_PANEL_EASE: Easing = [0.22, 1, 0.36, 1];
